module.exports = __webpack_public_path__ + "img/widgetabout-4.441ba526.jpg";